<question
  [quoteType]="quoteType"
  [asset_type]="'users_personal_details'"
  (showBackButton)="compShowBackButton($event)"
  (navigateQuestionSummary)="compNavigateQuestionSummary()"
  (navigateHomeQuote)="compNavigateHomeQuote()"
  (navigateWalletPage)="compNavigateWalletPage()"
></question>

